import { inject, InjectionToken } from '@angular/core';
import { AuthDashboardAccess, DashboardAccess } from './dashboard-access';
import { DashboardGridOptions, DashboardLayout } from './layout/dashboard-layout';
import { DashboardStateField } from './state/dashboard-state';
import { DashboardWidgetDefinition } from './widget/dashboard-widget-definition';
import { DashboardViewStore } from './views/dashboard-view';

export interface DashboardConfig {
  /** Stable id; part of the storage key for saved views */
  id: string;
  /** The built-in Default view */
  defaultLayout: DashboardLayout;
  grid: DashboardGridOptions;
  widgets: readonly DashboardWidgetDefinition[];
  state: readonly DashboardStateField[];
}

export const DASHBOARD_CONFIG = new InjectionToken<DashboardConfig>('DASHBOARD_CONFIG');
export const DASHBOARD_VIEW_STORE = new InjectionToken<DashboardViewStore>('DASHBOARD_VIEW_STORE');
export const DASHBOARD_ACCESS = new InjectionToken<DashboardAccess>('DASHBOARD_ACCESS', {
  factory: () => inject(AuthDashboardAccess),
});
